import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { TagPillWithLink } from '../common/components/TagPill';
export const TagPills = ({ tags, activeTagId = undefined, activeTagSlug = undefined, className = '', }) => {
    if (!(tags === null || tags === void 0 ? void 0 : tags.length))
        return null;
    return (_jsx("div", { className: twMerge('flex flex-wrap gap-2', className), children: tags.map(({ id, title, slug }) => (_jsx(TagPillWithLink, { link: `/search?query=${encodeURIComponent(title)}&type=post`, active: activeTagId === id || activeTagSlug === slug, title: title }, id))) }, void 0));
};
//# sourceMappingURL=TagPills.js.map